<div class="form-container">
    <h2>Edit Company User</h2>
    <div style="display: flex; gap: 20px; margin-bottom: 1rem;">
      <a [routerLink]="['/homeAdmin/v2/companies', companyId, 'users']" class="btn btn-secondary">
        ← Back to Users
      </a>
    </div>
    <form [formGroup]="userForm" (ngSubmit)="updateUser()"d>
      
      <div class="form-group">
        <label>Full Name:</label>
        <input type="text" class="form-control" formControlName="fullName" placeholder="Full Name">
        <div *ngIf="errors.fullName" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.fullName">{{ error }}</li>
          </ul>
        </div>
      </div>
  
      <div class="form-group">
        <label>Email:</label>
        <input type="email" class="form-control" formControlName="email" placeholder="Email">
        <div *ngIf="errors.email" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.email">{{ error }}</li>
          </ul>
        </div>
      </div>
  
      <div class="form-group">
        <label>Phone Number:</label>
        <input type="text" class="form-control" formControlName="phoneNumber" placeholder="Phone Number">
        <div *ngIf="errors.phoneNumber" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.phoneNumber">{{ error }}</li>
          </ul>
        </div>
      </div>
  
      <div class="form-group">
        <label>Department:</label>
        <input type="text" class="form-control" formControlName="department" placeholder="Department">
      </div>
  
      <div class="form-group">
        <label>Role:</label>
        <select class="form-control" formControlName="role">
          <option value="">Select a role</option>
          <option value="Super Admin">Super Admin</option>
          <option value="Master Admin">Master Admin</option>
          <option value="User">User</option>
        </select>
        <div *ngIf="errors.role" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.role">{{ error }}</li>
          </ul>
        </div>
      </div>
   
      <div class="form-group">
        <label>Permission:</label><br>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" formControlName="permission" value="Free" id="permissionFree">
          <label class="form-check-label" for="permissionFree">Free</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" formControlName="permission" value="Premium" id="permissionPremium">
          <label class="form-check-label" for="permissionPremium">Premium</label>
        </div>
      </div>
      
      <div class="form-group">
        <label>Permission Date:</label>
        <input type="date" class="form-control" formControlName="permissionDate">
      </div>
      
      <div class="form-group">
        <label>Access Permissions:</label><br>
        <div *ngFor="let permission of permissionsList; let i = index">
          <input
            type="checkbox"
            [value]="permission"
            (change)="onPermissionChange($event)"
            [checked]="accessFormArray.value.includes(permission)"
          />
          {{ permission }}
        </div>
      </div>
  
      <div *ngIf="errors.general" class="text-danger">
        <ul>
          <li *ngFor="let error of errors.general">{{ error }}</li>
        </ul>
      </div>
  
      

      <button type="submit" class="btn btn-primary">
        {{ isSubmitting ? 'Submitting...' : 'Edit User' }}
      </button>
  
    </form>
  </div>
  